import cartDarkImage from "assets/img/blackCart.png";
import { useSelector } from "react-redux";

const CartLogo = ({ variant = "large" }) => {
  const { cartItems } = useSelector((state) => state.cart);

  if (variant === "large") {
    return (
      <div
        style={{
          position: "relative",
          display: "inline-block",
          cursor: "pointer",
          width: "50px",
          padding: "0px",
        }}
      >
        <img
          src={cartDarkImage}
          style={{ maxWidth: "40px", maxHeight: "40px" }}
          className="w-full mr-2"
          alt="cart dark logo"
        />
        {cartItems?.length > 0 && (
          <div
            style={{
              position: "absolute",
              top: "0px",
              right: "3px",
              backgroundColor: "red",
              borderRadius: "100%",
              fontSize: "9px",
              color: "white",
              minWidth: "15px",
              height: "15px",
              padding: "3px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cartItems?.length}
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div
        style={{
          position: "relative",
          display: "inline-block",
          cursor: "pointer",
          width: "40px",
          padding: "0",
          marginRight : "5px",
          marginBottom: "5px",
        }}
      >
        <img
          src={cartDarkImage}
          style={{ maxWidth: "30px", maxHeight: "42px" }}
          className="w-full mr-2"
          alt="cart dark logo"
        />
        {cartItems?.length > 0 && (
          <div
            style={{
              position: "absolute",
              top: "0px",
              right: "3px",
              backgroundColor: "red",
              borderRadius: "100%",
              fontSize: "9px",
              color: "white",
              minWidth: "12px",
              height: "12px",
              padding: "3px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cartItems?.length}
          </div>
        )}
      </div>
    );
  }
};

export default CartLogo;
